import Home from '../pages/Home';
import Dashboard from '../pages/Dashboard';
import Oleg from '../pages/Oleg';
import Regex from '../pages/Regex';
import Calendar from '../pages/Calendar';
import QRcode from '../pages/QRcode';
import NotFoundPage from '../pages/NotFoundPage';
import BlockBastSandbox from '../pages/BlockBastSandbox';
import TicketsQuiz from '../pages/TicketsQuiz';
import Nadzor from '../pages/Nadzor';
import Auth from '../pages/Auth';

export const page_routes = [

    {   path: '/', 
        label: '',//'Главная',                          
        props: {}, 
        component: Home
    },

    {   path: '/dashboard', 
        label: 'Дашборд',                   
        props: {},           
        component: Dashboard 
    },

    //{   path: '/oleg',  
    //    label: 'Валентинка',
    //    props: {},      
    //    component: Oleg 
    //},

    {   path: '/regex', 
        label: 'РегВыр',
        props: {},      
        component: Regex 
    },

    {   path: '/calendar',  
        label: 'Твой личный календарик 💖', 
        props: {},          
        component: Calendar 
    },

    {   path: '/qrcode', 
        label: 'Генератор QR-кодов', 
        props: {},        
        component: QRcode 
    },
 
    {   path: '/blockbast', 
        label: 'БлокБаст!',
        props: {},          
        component: BlockBastSandbox 
    },

    {
        path: '/quiz',
        label: 'Погоны',
        props: {},
        component: TicketsQuiz
    },

    {   path: '/nadzor',  
        label: 'Надзор', 
        props: {}, 
        component: Nadzor,
        protected: true,
        adminOnly: true
    },

    {   path: '/auth',  
        label: 'Авторизация', 
        props: {
            override_styles: ['nav-link-right', 'auth-btn']
        },      
        component: Auth 
    },


    // Must be last 

    {   path: '*',  
        label: '',
        props: {},               
        component: NotFoundPage 
    },


];
